import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'

import Modal from "../../shared/modal/Modal"
import ClientSearchModal from './ClientSearchModal'

// Reaproveita o CSS do trigger de NCM — mesmo visual de input+botão colado.
import '../../shared/css/inputGroup.css'

// Campo de Nome/Razão Social com um botão de busca colado — abre um modal pra
// selecionar um cliente cadastrado e autopreencher o destinatário (ver ClientSearchModal.js).
// O campo continua um texto livre normal — dá pra digitar direto sem nunca abrir a busca.
function ClientSearchTrigger({ name, value, handleOnChange, onSelect }) {
    const [modalClient, setModalClient] = useState(false)

    function handlePicked(c) {
        onSelect(c)
        setModalClient(false)
    }

    return (
        <>
            <div className="ncm-input-group">
                <input className="input ncm-input-group-input" type="text" name={name} value={value || ''} onChange={handleOnChange} />
                <button type="button" className="ncm-input-group-btn" title="Buscar cliente cadastrado" onClick={() => setModalClient(true)}>
                    <PiMagnifyingGlassDuotone size={23} />
                </button>
            </div>

            <Modal
                modalStatus={modalClient}
                changeStatus={setModalClient}
                w={55}
                content={<ClientSearchModal onSelect={handlePicked} />}
            />
        </>
    )
}

export default ClientSearchTrigger
